import ThirdParties from './ThirdParties'

export default ThirdParties
